import { Controller } from "@hotwired/stimulus"

// Shows its "field" target only while a select inside it has a given value, e.g. a "what kind?"
// text field that only applies to the select's "Something else" option. Listens for the change
// event on the element itself, which the custom select dispatches (and bubbles) when a choice is
// made. A hidden field is also disabled, so it isn't submitted or required while it doesn't apply.
export default class extends Controller {
  static targets = ["field"]
  static values = { when: String }

  connect() {
    this.update()
  }

  update() {
    const select = this.element.querySelector("select")
    const show = select && select.value === this.whenValue
    this.fieldTarget.hidden = !show
    this.fieldTarget.querySelectorAll("input, textarea").forEach((input) => { input.disabled = !show })
  }
}
